import { render, staticRenderFns } from "./ViewTargetGroup.vue?vue&type=template&id=6bed9fca"
import script from "./ViewTargetGroup.vue?vue&type=script&lang=js"
export * from "./ViewTargetGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports